import { __spreadArrays } from "tslib";
import * as _ from 'lodash';
import { isAppWidgetType, AppLevel, } from '../types/content';
import { BlogStructures, EventSingleStructures, getAppTypeByWidgetType, PhotographerStructures, PreferredAppByStructure, RecommendedAppByStructure, StoresStructures, } from './constants';
import { appToAppDefId, AppType } from '@wix/adi-core-types';
export function getApps(params, flags) {
    var content = params.content, structureId = params.structureId;
    var homePageSections = _.get(content, ['pages', '0', 'sections']);
    var builtInHardcodedApps = getBuiltInHardcodedApps(structureId);
    var preferredAppsFromSiteStructure = getAppsFromSiteStructure(content === null || content === void 0 ? void 0 : content.pages, flags);
    var preferredHardcodedApps = getPreferredHardcodedApps(structureId);
    var preferredHomePageApps = getAppsFromSiteHomePage(homePageSections);
    var recommendedStructureApps = getAppsFromStructure(content === null || content === void 0 ? void 0 : content.recommendedApps);
    var recommendedHardcodedApps = getHardcodedRecommendedAppsByStructureId(structureId);
    var regularApps = getRegularApps();
    var apps = _.uniqBy(__spreadArrays(builtInHardcodedApps, preferredHomePageApps, preferredAppsFromSiteStructure, preferredHardcodedApps, recommendedStructureApps, recommendedHardcodedApps, regularApps), 'type').filter(function (app) {
        // Stores shouldn't be available if photographer structure selected
        if (app.type === AppType.Stores &&
            PhotographerStructures.has(structureId)) {
            return false;
        }
        return true;
    });
    var getSubscribersApp = apps.find(function (app) { return app.type === AppType.GetSubscribers; });
    if (getSubscribersApp) {
        var formsApp = apps.find(function (app) { return app.type === AppType.Forms; });
        // Forms app should has same source and level GetSubscribers app
        if (formsApp) {
            formsApp.source = getSubscribersApp.source;
            formsApp.level = getSubscribersApp.level;
        }
    }
    return apps;
}
function getHardcodedPreferredAppsByStructureId(structureId) {
    var allApps = Object.values(AppType);
    var preferredApps = [];
    allApps.forEach(function (appType) {
        var appStructures = PreferredAppByStructure[appType];
        var preferred = Boolean(appStructures === null || appStructures === void 0 ? void 0 : appStructures.has(structureId));
        if (preferred) {
            preferredApps.push({
                type: appType,
                level: AppLevel.Preferred,
                source: 'hardcoded',
                appDefId: appToAppDefId(appType),
            });
        }
    });
    return preferredApps;
}
function getHardcodedRecommendedAppsByStructureId(structureId) {
    var allApps = Object.values(AppType);
    // TODO this have to be removed when PaidPlan will be added to CMS
    var recommendedApps = [];
    allApps.forEach(function (appType) {
        var appStructures = RecommendedAppByStructure[appType];
        var recommended = Boolean(appStructures === null || appStructures === void 0 ? void 0 : appStructures.has(structureId));
        if (recommended) {
            recommendedApps.push({
                type: appType,
                level: AppLevel.Recommended,
                source: 'hardcoded',
                appDefId: appToAppDefId(appType),
            });
        }
    });
    return recommendedApps;
}
function getRegularApps() {
    var allApps = Object.values(AppType);
    return allApps.map(function (appType) {
        return {
            type: appType,
            level: AppLevel.Regular,
            source: 'hardcoded',
            appDefId: appToAppDefId(appType),
        };
    });
}
function getAppsFromSiteHomePage(homePageSections) {
    if (!homePageSections) {
        return [];
    }
    var homePageApps = homePageSections
        .filter(function (section) { return isAppWidgetType(section.ceType); })
        .map(function (section) {
        var appType = normalizeAppNames(section.ceType);
        return {
            type: appType,
            level: AppLevel.Preferred,
            source: 'site-structure',
            appDefId: appToAppDefId(appType),
        };
    });
    if (shouldAddBookings(homePageSections)) {
        homePageApps.push({
            type: AppType.Bookings,
            level: AppLevel.Preferred,
            source: 'site-structure',
            appDefId: appToAppDefId(AppType.Bookings),
        });
    }
    return homePageApps;
}
function getAppsFromSiteStructure(sitePages, flags) {
    if (!sitePages) {
        return [];
    }
    var nonOptionalPages = sitePages.filter(function (page) { return !page.optional; });
    var sections = _.flatMap(nonOptionalPages, function (page) { return page.sections; });
    var structureApps = sections.map(function (section) {
        var appType = normalizeAppNames(section.ceType);
        return {
            type: appType,
            level: AppLevel.Preferred,
            source: 'site-structure',
            appDefId: appToAppDefId(appType),
        };
    });
    var preferredApps = [];
    var structureAppsSet = new Set(structureApps.map(function (app) { return app.type; }));
    var hasRestaurantMenus = structureAppsSet.has(AppType.RestaurantsMenus);
    if (hasRestaurantMenus) {
        preferredApps.push({
            type: AppType.RestaurantsMenus,
            level: AppLevel.Preferred,
            source: 'site-structure',
            appDefId: appToAppDefId(AppType.RestaurantsMenus),
        });
    }
    var hasRestaurantOrders = structureAppsSet.has(AppType.RestaurantsOrders);
    if (hasRestaurantOrders) {
        preferredApps.push({
            type: AppType.RestaurantsOrders,
            level: AppLevel.Preferred,
            source: 'site-structure',
            appDefId: appToAppDefId(AppType.RestaurantsOrders),
        });
    }
    var hasForumApp = structureAppsSet.has(AppType.Forum);
    if (hasForumApp) {
        preferredApps.push({
            type: AppType.Forum,
            level: AppLevel.Preferred,
            source: 'site-structure',
            appDefId: appToAppDefId(AppType.Forum),
        });
    }
    return preferredApps;
}
function shouldAddBookings(homePageSections) {
    return Boolean(homePageSections === null || homePageSections === void 0 ? void 0 : homePageSections.some(function (section) {
        return section.syncWithBooking && section.syncWithBooking !== 'none';
    }));
}
function getAppsFromStructure(recommendedApps) {
    var _a;
    if (!recommendedApps) {
        return [];
    }
    return ((_a = recommendedApps.map(function (type) {
        var appType = normalizeAppNames(type);
        return {
            type: appType,
            level: AppLevel.Recommended,
            source: 'cms-recommended',
            appDefId: appToAppDefId(appType),
        };
    })) !== null && _a !== void 0 ? _a : []);
}
function normalizeAppNames(type) {
    if (type === 'Blog2') {
        return AppType.Blog;
    }
    return getAppTypeByWidgetType(type);
}
function getPreferredHardcodedApps(structureId) {
    var preferredApps = [];
    preferredApps.push({
        type: AppType.Chat,
        level: AppLevel.Preferred,
        source: 'hardcoded',
        appDefId: appToAppDefId(AppType.Chat),
    });
    var preferredByIndustry = getHardcodedPreferredAppsByStructureId(structureId);
    preferredApps.push.apply(preferredApps, preferredByIndustry);
    return preferredApps;
}
function getBuiltInHardcodedApps(structureId) {
    var builtInApps = [];
    if (EventSingleStructures.has(structureId)) {
        builtInApps.push({
            type: AppType.Events,
            level: AppLevel.BuiltIn,
            source: 'hardcoded',
            appDefId: appToAppDefId(AppType.Events),
        });
    }
    if (StoresStructures.has(structureId)) {
        builtInApps.push({
            type: AppType.Stores,
            level: AppLevel.BuiltIn,
            source: 'hardcoded',
            appDefId: appToAppDefId(AppType.Stores),
        });
    }
    if (BlogStructures.has(structureId)) {
        builtInApps.push({
            type: AppType.Blog,
            level: AppLevel.BuiltIn,
            source: 'hardcoded',
            appDefId: appToAppDefId(AppType.Blog),
        });
    }
    return builtInApps;
}
//# sourceMappingURL=apps.js.map